import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TabParagraphContainerComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-tab-paragraph-container',
  templateUrl: './tab-paragraph-container.component.html',
  styleUrl: './tab-paragraph-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomTabParagraphContainerComponent extends TabParagraphContainerComponent {}
